<template>
  <NumeraiModal
    ref="modal"
    :dialog="dialog"
    :button="false"
    title="Update Account Profile"
    save-button-text="Update"
    :disabled="updating"
    :save-callback="save"
    @close="close"
  >
    <template v-slot:activator>
      <slot></slot>
    </template>
    <div class="input">
      <div class="label">
        Username
      </div>
      <input
        v-model="username"
        class="numerai-input full-width"
        @input="onUsernameChange"
      />
      <div class="numerai-form-error">{{ usernameError }}</div>
    </div>
    <div class="input">
      <div class="label">
        Display name
      </div>
      <input v-model="fields.displayName" class="numerai-input full-width" />
    </div>
    <div class="input">
      <div class="label">
        Personal bio
      </div>
      <input v-model="fields.bio" class="numerai-input full-width" />
    </div>
    <div class="input">
      <div class="label">
        Location
      </div>
      <input
        v-model="fields.location"
        class="numerai-input full-width"
        placeholder="Mars"
      />
    </div>
    <div class="input">
      <div class="label">
        Discord <span v-if="fields.discord.userId">(</span
        ><a
          v-if="fields.discord.userId"
          :href="`https://discordapp.com/users/${fields.discord.userId}`"
          target="_blank"
          rel="noopener noreferrer"
          class="text_decoration_none"
          >https://discordapp.com/users/{{ fields.discord.userId }}</a
        ><span v-if="fields.discord.userId">)</span>
        <div v-if="fields.discord.userId">
          <button class="numerai-button" @click="removeDiscordLink()">
            Remove
          </button>
        </div>

        <div v-else>
          <a :href="discordAuthLink()">
            <button class="numerai-button">
              Connect Discord account
            </button>
          </a>
        </div>
      </div>
    </div>
    <div class="input">
      <div class="label">
        Twitter/X <span v-if="fields.twitter">(</span
        ><a
          v-if="fields.twitter"
          :href="`https://twitter.com/${fields.twitter}`"
          target="_blank"
          rel="noopener noreferrer"
          class="text_decoration_none"
          >twitter.com/{{ fields.twitter }}</a
        ><span v-if="fields.twitter">)</span>
      </div>
      <input
        v-model="fields.twitter"
        class="numerai-input full-width"
        placeholder="Twitter username"
      />
    </div>
    <div class="input">
      <div class="label">
        GitHub <span v-if="fields.github">(</span
        ><a
          v-if="fields.github"
          :href="`https://github.com/${fields.github}`"
          target="_blank"
          rel="noopener noreferrer"
          class="text_decoration_none"
          >github.com/{{ fields.github }}</a
        ><span v-if="fields.github">)</span>
      </div>
      <input
        v-model="fields.github"
        class="numerai-input full-width"
        placeholder="GitHub username"
      />
    </div>
    <div class="input">
      <div class="label">
        Linkedin <span v-if="fields.linkedin">(</span
        ><a
          v-if="fields.linkedin"
          :href="`https://linkedin.com/in/${fields.linkedin}`"
          target="_blank"
          rel="noopener noreferrer"
          class="text_decoration_none"
          >linkedin.com/in/{{ fields.linkedin }}</a
        ><span v-if="fields.linkedin">)</span>
      </div>
      <input
        v-model="fields.linkedin"
        class="numerai-input full-width"
        placeholder="Linkedin username"
      />
    </div>
    <div class="input">
      <div class="label">
        Kaggle <span v-if="fields.kaggle">(</span
        ><a
          v-if="fields.kaggle"
          :href="`https://kaggle.com/${fields.kaggle}`"
          target="_blank"
          rel="noopener noreferrer"
          class="text_decoration_none"
          >kaggle.com/{{ fields.kaggle }}</a
        ><span v-if="fields.kaggle">)</span>
      </div>
      <input
        v-model="fields.kaggle"
        class="numerai-input full-width"
        placeholder="Kaggle username"
      />
    </div>
    <div class="input">
      <div class="label">
        Website
      </div>
      <input v-model="fields.website" class="numerai-input full-width" />
    </div>
    <span class="color-error">{{ errorMsg }}</span>
  </NumeraiModal>
</template>

<script>
import NumeraiModal from '@/components/shared/NumeraiModal'
import _ from 'lodash'

export default {
  components: {
    NumeraiModal,
  },
  props: {
    dialog: { type: Boolean, default: false },
    accountMeta: { type: Object, default: null },
    discordLinkToken: { type: String, default: null },
    onClose: { type: Function, default: () => {} },
    onUpdate: { type: Function, default: () => {} },
  },
  data() {
    return {
      updating: false,
      fields: {},
      username: null,
      errorMsg: '',
      usernameError: '',
    }
  },
  computed: {
    formattedFields() {
      return {
        bio: this.fields.bio,
        displayName: this.fields.displayName,
        github: this.fields.github,
        kaggle: this.fields.kaggle,
        linkedin: this.fields.linkedin,
        location: this.fields.location,
        occupation: this.fields.occupation,
        organization: this.fields.organization,
        twitter: this.fields.twitter,
        discord: this.fields.discord,
        website: this.fields.website,
      }
    },
  },
  created() {
    this.fields = { ...this.accountMeta }
    this.username = this.accountMeta.username
  },
  methods: {
    close() {
      this.onClose()
    },
    async save() {
      this.updating = true

      try {
        this.msg = ''
        await this.$client.updateAccountProfile(this.formattedFields)

        if (this.username !== this.accountMeta.username) {
          try {
            await this.$client.renameAccount(this.username)
            this.$store.dispatch('updateUsername', this.username)
          } catch (e) {
            this.errorMsg = e.message
            return
          }
        }

        if (this.username !== this.accountMeta.username) {
          this.$router.push(`/~${this.username}`)
          window.location.reload()
        } else {
          this.$refs.modal.close()
          this.onUpdate()
          this.onClose()
        }
      } catch (e) {
        this.errorMsg = e.message
      }
      this.updating = false
    },
    async removeDiscordLink() {
      this.updating = true
      try {
        await this.$client.removeDiscordAccountLink()
        this.$refs.modal.close()
        this.onUpdate()
        this.onClose()
      } catch (e) {
        this.errorMsg = e.message
      }
      this.updating = false
    },
    onUsernameChange(e) {
      const username = e.target.value
      if (username !== this.accountMeta.username) {
        this.checkNameAvailable(username)
      }
    },
    checkNameAvailable: _.debounce(async function(name) {
      try {
        await this.$client.nameCheck(name)
        this.usernameError = null
      } catch (e) {
        this.usernameError = e.message
      }
    }, 300),
    discordAuthLink() {
      const clientId = '1161024433419472937'
      const baseUrl = this.$client.BACKEND_URL
      // const redirectUri = 'https://api-tournament.numer.ai/discord-auth-callback'
      const redirectUri = baseUrl + 'discord-auth-callback'
      const responseType = 'code'
      const scope = 'identify'
      const state = this.discordLinkToken

      const discordAuthUrl = new URL('https://discord.com/api/oauth2/authorize')

      discordAuthUrl.searchParams.append('client_id', clientId)
      discordAuthUrl.searchParams.append('redirect_uri', redirectUri)
      discordAuthUrl.searchParams.append('response_type', responseType)
      discordAuthUrl.searchParams.append('scope', scope)
      discordAuthUrl.searchParams.append('state', state)
      return discordAuthUrl.href
    },
  },
}
</script>
<style scoped>
.label {
  font-size: 16px;
  margin-bottom: 6px;
}

.input {
  margin-bottom: 12px;
}

.numerai-input {
  font-size: 16px;
}
</style>
